import React, { useCallback } from 'react';

import { ModalWrapper } from '@/components/wrappers';

import ViewPlanTerminationModalForm from './PlanTerminationModalForms/ViewPlanTerminationModalForm';
import { useViewPlanTerminationModalStore } from './store';

export const ViewPlanTerminationModal = () => {
  const handleChangeVisibility = useViewPlanTerminationModalStore((state) => state.handleChangeVisibility);
  const modalVisible = useViewPlanTerminationModalStore((state) => state.modalVisible);

  const handleSetVisible = useCallback(() => {
    handleChangeVisibility(false);
  }, [
    handleChangeVisibility,
  ]);

  return (
    <ModalWrapper
      testId="ViewPlanTerminationModal_ModalWrapper"
      visible={modalVisible}
      onSetVisible={handleSetVisible}
    >
      <ViewPlanTerminationModalForm />
    </ModalWrapper>
  );
};